module.exports = __webpack_public_path__ + "img/reset.98cc65c0.png";